var _defs, _path, _path2, _path3, _path4, _path5, _use, _use2, _g, _g2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 600,
    width: 1200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h600v300H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 300 150H0zm300 0h300L300 150zm0 150h300v150zm0 0v150H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v.5L1 0z",
    transform: "translate(0 -.325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-.5L1 0z",
    transform: "rotate(-36 .5 -.162)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1 1) rotate(72)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h1200v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "m0 0 600 300M0 300 600 0",
    strokeWidth: 60,
    clipPath: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C8102E",
    d: "m0 0 600 300M0 300 600 0",
    strokeWidth: 40,
    clipPath: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M300 0v300M0 150h600",
    strokeWidth: 100,
    clipPath: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C8102E",
    d: "M300 0v300M0 150h600",
    strokeWidth: 60,
    clipPath: "url(#b)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#FFF",
    transform: "matrix(45.4 0 0 45.4 900 120)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#C8102E",
    transform: "matrix(30 0 0 30 900 120)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 900 240)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#FFF",
    transform: "rotate(-82 519.022 -457.666) scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#C8102E",
    transform: "rotate(-82 519.022 -457.666) scale(25)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 900 240)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#FFF",
    transform: "rotate(-82 668.57 -327.666) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#C8102E",
    transform: "rotate(-82 668.57 -327.666) scale(30)"
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#FFF",
    transform: "matrix(50.4 0 0 50.4 900 480)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#C8102E",
    transform: "matrix(35 0 0 35 900 480)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/nz.2f81d400ba0f1f2d1a478ac3bedb7ad6.svg";
export { ForwardRef as ReactComponent };